var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6317 21.4708C27.4788 21.4708 32.2189 16.7308 32.2189 10.8836C32.2189 5.03645 27.4788 0.296387 21.6317 0.296387C15.7845 0.296387 11.0444 5.03645 11.0444 10.8836C11.0444 16.7308 15.7845 21.4708 21.6317 21.4708Z",
    fill: "#004B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8887 40.8261H28.4165V43.1206H39.8887V40.8261Z",
    fill: "#004B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5833 44.1039V49.0205C18.5833 49.4552 18.756 49.8721 19.0633 50.1794C19.3707 50.4868 19.7875 50.6594 20.2222 50.6594H48.0833C48.518 50.6594 48.9348 50.4868 49.2422 50.1794C49.5495 49.8721 49.7222 49.4552 49.7222 49.0205V32.6317C49.7222 32.197 49.5495 31.7801 49.2422 31.4728C48.9348 31.1654 48.518 30.9928 48.0833 30.9928H36.6111V28.5836C36.6111 28.1489 36.4384 27.7321 36.1311 27.4247C35.8237 27.1174 35.4068 26.9447 34.9722 26.9447C34.5375 26.9447 34.1207 27.1174 33.8133 27.4247C33.506 27.7321 33.3333 28.1489 33.3333 28.5836V30.9928H30.0555V25.1255C27.2705 24.6707 24.4535 24.4405 21.6316 24.4372C15.4084 24.4107 9.25498 25.7477 3.60386 28.3542C2.67376 28.7931 1.8891 29.4896 1.34297 30.3611C0.796843 31.2326 0.512175 32.2424 0.522745 33.2708V44.1039H18.5833ZM46.4444 47.3817H21.8611V34.2705H33.3333V34.9589C33.3333 35.3935 33.506 35.8104 33.8133 36.1178C34.1207 36.4251 34.5375 36.5978 34.9722 36.5978C35.4068 36.5978 35.8237 36.4251 36.1311 36.1178C36.4384 35.8104 36.6111 35.3935 36.6111 34.9589V34.2705H46.4444V47.3817Z",
    fill: "#004B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5 0.437012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIcon);
export default __webpack_public_path__ + "static/media/employee-icon.e2333a304f645c0d2fbd1b335a5ec02f.svg";
export { ForwardRef as ReactComponent };